import clsx from 'clsx';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import React from 'react';

interface SidebarProps {
  position?: 'left' | 'right';
  className?: string;
  children: React.ReactNode;
}

const Sidebar = ({ position = 'left', className, children }: SidebarProps) => {
  return (
    <aside
      className={clsx(
        'fixed bottom-0 top-14 z-50 flex min-h-full w-[60px] flex-1 flex-col overflow-y-auto bg-background transition-all duration-300 lg:w-[205px]',
        position === 'right' ? 'right-0' : 'left-0',
        className
      )}
    >
      <div className="flex h-full flex-col gap-y-5 pb-20 pt-4 text-white">
        <OverlayScrollbarsComponent
          options={{
            paddingAbsolute: true,
            scrollbars: {
              autoHide: 'leave',
              autoHideDelay: 100,
            },
          }}
          defer
        >
          {children}
        </OverlayScrollbarsComponent>
      </div>
    </aside>
  );
};

export default Sidebar;
